export const AppConfig = {
  apiHost: import.meta.env.VITE_APPY_HOST_API,
  cdnHost: import.meta.env.VITE_APPY_HOST_CDN,
  appId: import.meta.env.VITE_APPY_PLATFORM_WEB_APPID,

  datadogKey: import.meta.env.VITE_DATADOG_API_KEY,
};
